import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    num: '01',
    title: 'Protocolo de Alivio Digestivo Inmediato',
    items: ['El protocolo de 3 niveles para cuando la hinchazón aparece ahora mismo'],
    value: '$15.000'
  }, {
    num: '02',
    title: 'Agenda de Comidas Seguras 7 Días',
    items: ['7 días de menús completos ya armados', 'Lista de compras incluida'],
    value: '$12.000'
  }, {
    num: '03',
    title: 'Checklist "Antes de Comer Afuera"',
    items: ['Guía para parrillas, pizzerías y reuniones', 'Volvés a casa sin sentirte destruida'],
    value: '$10.000'
  }, {
    num: '04',
    title: 'Plantilla "Mi Semáforo Personal de Gatillos"',
    items: ['Tu clasificación de alimentos seguros, dudosos y prohibidos', 'Para siempre'],
    value: '$11.000'
  }, {
    num: '05',
    title: 'Manual de Respuestas Firmes y Elegantes',
    items: ['Las frases exactas para frenar la presión social', 'Sin pelearte con nadie'],
    value: '$10.000'
  }];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-30">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[600px] bg-brand-gold/5 blur-[150px] rounded-full pointer-events-none" data-id="element-31" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-32">
        <div className="max-w-5xl mx-auto" data-id="element-33">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-34">
            <h2 className="text-3xl md:text-5xl font-bold text-brand-gold mb-4 flex flex-col md:flex-row items-center justify-center gap-4 font-[Poppins,_sans-serif]" data-id="element-35">
              <Gift className="w-10 h-10" data-id="element-36" />5 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-xl text-white font-medium tracking-widest uppercase" data-id="element-37">
              Siempre incluidos. Siempre gratis.
            </p>
          </motion.div>

          <div className="grid gap-6 mb-16" data-id="element-38">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-brand-dark border border-brand-gold/20 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-start relative overflow-hidden group hover:border-brand-gold/50 transition-colors" data-id="element-39">
                <div className="bg-brand-gold/10 text-brand-gold font-bold text-xl px-4 py-2 rounded-lg shrink-0" data-id="element-40">
                  BONO {bonus.num}
                </div>

                <div className="flex-grow z-10" data-id="element-41">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-42">
                    {bonus.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-43">
                    {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-44">
                        <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-45" />
                        <span data-id="element-46">{item}</span>
                      </li>)}
                  </ul>
                </div>

                <div className="shrink-0 flex flex-row items-center gap-3 z-10" data-id="element-47">
                  <span className="text-gray-500 line-through text-sm" data-id="element-48">
                    {bonus.value}
                  </span>
                  <span className="bg-brand-light text-brand-dark font-bold px-4 py-1 rounded-full" data-id="element-49">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-brand-gold/10 border border-brand-gold/30 py-8 px-6 rounded-2xl flex flex-col items-center justify-center gap-2" data-id="element-50">
            <p className="text-sm md:text-base font-semibold tracking-widest uppercase text-[#D4A843]" data-id="element-51">
              VALOR TOTAL BONOS
            </p>
            <p className="text-3xl md:text-4xl font-bold text-gray-400 line-through" data-id="element-52">
              $58.000
            </p>
            <p className="text-xl md:text-2xl text-brand-gold font-bold text-center" data-id="element-53">
              → GRATIS con tu Sistema Bitácora de Conexión Digestiva™
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}